import Api from "./Api";
import store from "../state/store";

export default {
  getJourneys() {
    return Api().get(`/journeys/${store.getters["authfack/currentEntity"].id}`);
  },
  getJourneyFlows (site_ids) {
    return Api().get(`sites_userTypes_flow`, {
      params: {
        site_ids: site_ids
      },
    });
  },
  
  getJourneyFlowsDetails(journeyFlow_id) {
    return Api().get(`journey_flow_details/${journeyFlow_id}`);
  },
  getJourneysNormal(siteId) {
    return Api().get(`/journeys/site/${siteId}`);
  },
  getJourneysRemote(siteId) {
    return Api().get(`/journeys/remote/${siteId}`);
  },
  createJourney(params) {
    return Api().post("/journey", params);
  },
  updateJourney(params, journey_id) {
    return Api().post(`/journey/${journey_id}`,
      params
    );
  },
  deleteJourney(id) {
    return Api().delete(`/journey/${id}`);
  },
  getJourneyDetails(id) {
    return Api().get(`/journey/${id}`);
  },
  getJourneyChecks(joruneyDetails) {
    return Api().get('/get_setting_from_flow', {
      params: {
        userId: joruneyDetails.userId,
        siteId: joruneyDetails.siteId,
        journeyId: joruneyDetails.journeyId,
        userTypeId: joruneyDetails.userTypeId,
        type: joruneyDetails.type
      }
    });
  },
  getUserTypeRelatedToJourney(id) {
    return Api().get(`/get_user_type_related_to_journey/${id}`);
  },
  getRegistrationNotRequiredUserTypeCount(journeyId) {
    return Api().get(`/user-types/count/${journeyId}`)
  },
  getJourneyInputs(id) {
    return Api().get(`/check_journey_have_input/${id}`);
  },
  changeJourney(params) {
    const data = { kiosk: { journey_id: params.journey_id, area_id: params.area_id } };
    return Api().put(`/change_journey_for_kiosk/${params.kiosk_id}`, data);
  },

  qrUserTypes(id) {
    return Api().get(`/user-type-qr/${id}`);
  },
  flowInfo(flowId) {
    return Api().get(`/journey_flow/${flowId}`)
  },
  validateRemoteJourney(params) {
    return Api().post("/validate-update-journey", params);
  },
  journeyNewFlow(journeyId){
    return Api().get(`journey_flow_builder/${journeyId}`)
  }
};
